import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thaiDate',
  standalone: true,
})
export class ThaiDatePipe implements PipeTransform {

  private thaiMonths = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
    'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
    'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ];

  private toThaiNumber(input: number | string): string {
    const thaiDigits = ['๐', '๑', '๒', '๓', '๔', '๕', '๖', '๗', '๘', '๙'];
    return input.toString().split('').map(d => {
      return /\d/.test(d) ? thaiDigits[+d] : d;
    }).join('');
  }

   formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate();
    const month = this.thaiMonths[date.getMonth()];
    const year = date.getFullYear() + 543;

    return `${day} ${month} ${year}`;
  }

  formatDate2(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate();
    const month = this.thaiMonths[date.getMonth()];
    const year = date.getFullYear() + 543;

    return `${day} ${month} ${year}`;
  }
  formatThaiDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = this.toThaiNumber(date.getDate());
    const month = this.thaiMonths[date.getMonth()];
    const year = this.toThaiNumber(date.getFullYear() + 543);

    return `${day} ${month} ${year}`;
  }


  formatThaiDatenoYear(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = this.toThaiNumber(date.getDate());
    const month = this.thaiMonths[date.getMonth()];
    const year = this.toThaiNumber(date.getFullYear() + 543);

    return `${day} ${month} ${year}`;
  }
  transform(
    value: string | Date,
    fullMonth: boolean = false,
    shortYear: boolean = false,
    hideYear: boolean = false,
    useThaiTimezone: boolean = false,
    useDefaultTimezone: boolean = false
  ): string {
    if (!value) return '';

    let date = new Date(value);

    if (useThaiTimezone) {
      date = new Date(date.getTime() + 7 * 60 * 60 * 1000);
    }

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear() + 543;

    const displayYear = hideYear
      ? ''
      : shortYear
      ? this.shortYear(year.toString())
      : year.toString();

    const datePart = `${day} ${this.getMonthInThai(
      month,
      fullMonth
    )} ${displayYear}`.trim();

    if (useThaiTimezone || useDefaultTimezone) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const timePart = `${hours}.${minutes} น.`;

      return `${datePart}\u00A0\u00A0${timePart}`;
    }

    return datePart;
  }

  private shortYear(year: string) {
    return /^25\d{2}$/.test(year) ? year.slice(2) : '';
  }

  private getMonthInThai(month: Month, full: boolean = false): string {
    const shortMonths: { [key in Month]: string } = {
      [Month.Jan]: 'ม.ค.',
      [Month.Feb]: 'ก.พ.',
      [Month.Mar]: 'มี.ค.',
      [Month.Apr]: 'เม.ย.',
      [Month.May]: 'พ.ค.',
      [Month.Jun]: 'มิ.ย.',
      [Month.Jul]: 'ก.ค.',
      [Month.Aug]: 'ส.ค.',
      [Month.Sep]: 'ก.ย.',
      [Month.Oct]: 'ต.ค.',
      [Month.Nov]: 'พ.ย.',
      [Month.Dec]: 'ธ.ค.',
    };

    const fullMonths: { [key in Month]: string } = {
      [Month.Jan]: 'มกราคม',
      [Month.Feb]: 'กุมภาพันธ์',
      [Month.Mar]: 'มีนาคม',
      [Month.Apr]: 'เมษายน',
      [Month.May]: 'พฤษภาคม',
      [Month.Jun]: 'มิถุนายน',
      [Month.Jul]: 'กรกฎาคม',
      [Month.Aug]: 'สิงหาคม',
      [Month.Sep]: 'กันยายน',
      [Month.Oct]: 'ตุลาคม',
      [Month.Nov]: 'พฤศจิกายน',
      [Month.Dec]: 'ธันวาคม',
    };

    return full ? fullMonths[month] : shortMonths[month];
  }
}

enum Month {
  Jan = 0,
  Feb = 1,
  Mar = 2,
  Apr = 3,
  May = 4,
  Jun = 5,
  Jul = 6,
  Aug = 7,
  Sep = 8,
  Oct = 9,
  Nov = 10,
  Dec = 11,
}



